// extracted by mini-css-extract-plugin
export default {"text":"ProText__text___JnV5s"};